import { Location } from 'history';
import * as React from 'react';
import { match, Redirect, Route, RouteComponentProps, Switch } from 'react-router';

import { connect, MapStateToProps } from 'react-redux';
import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { AppState } from '../../app/state/AppState';
import { ReactDirectiveProps } from '../../ts/directives/reactDirectiveFactory';
import { FlowSpaceProvider } from './FlowSpaceProvider';

export interface FlowRouteParams {
  readonly id: string;
}

export interface FlowRouteComponentProps extends RouteComponentProps<FlowRouteParams> {
  readonly match: match<FlowRouteParams>;
  readonly location: Location;
}

export interface FlowSpaceRouterOwnProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly previousUrl: string;
  readonly urls: SpacesSiteUrls;
}

export interface FlowSpaceRouterStateProps {
  readonly isRequestAccessEnabled: boolean;
}

export type FlowSpaceRouterProps = FlowRouteComponentProps & FlowSpaceRouterOwnProps & FlowSpaceRouterStateProps;

export class FlowSpaceRouterComponent extends React.Component<FlowSpaceRouterProps, {}> {

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.flowPublishresultPath(':id')} render={(routeProps: FlowRouteComponentProps) =>
          <Redirect to={this.props.urls.flowOverviewPath(routeProps.match.params.id)}/>
        }/>
        <Route exact path={this.props.urls.flowPath(':id')} render={(routeProps: FlowRouteComponentProps) =>
          <Redirect to={this.props.urls.flowOverviewPath(routeProps.match.params.id)}/>
        }/>
        <Route exact path={this.props.urls.flowOverviewPath(':id')} render={this.flowSpaceProviderFor('overview')}/>
        <Route exact path={this.props.urls.flowConnectionsPath(':id')} render={this.flowSpaceProviderFor('connections')}/>
        <Route exact path={this.props.urls.flowScheduledTasksPath(':id')} render={this.flowSpaceProviderFor('scheduledTasks')}/>
        <Route exact path={this.props.urls.flowRunHistoryPath(':id')} render={this.flowSpaceProviderFor('runHistory')}/>
        <Route path={this.props.urls.flowLineagePath(':id')} render={this.flowSpaceProviderFor('lineage')}/>
        <Route render={() => <RouterError errorType={'default'} urls={this.props.urls}/>}/>
      </Switch>
    );
  }

  private flowSpaceProviderFor = (subplace: string): (routeProps: FlowRouteComponentProps) => JSX.Element => {
    return (routeProps: FlowRouteComponentProps) => {
      const flowId = routeProps.match.params.id;
      const showPublishResult = this.props.previousUrl.includes(this.props.urls.flowPublishresultUrl(flowId));
      return <FlowSpaceProvider
        siteName={this.props.siteName}
        angularContext={this.props.angularContext}
        flowId={flowId}
        siteUrls={this.props.urls}
        subplaceName={subplace}
        routeLocationSearch={routeProps.location.search}
        routeLocationPath={routeProps.location.pathname}
        showPublishResult={showPublishResult}
        isRequestAccessEnabled={this.props.isRequestAccessEnabled}
      />;
    };
  }
}

const mapStateToProps: MapStateToProps<FlowSpaceRouterStateProps, FlowSpaceRouterOwnProps, {}> = (state: AppState) => ({
  isRequestAccessEnabled: SessionSiteSelectors.isRequestAccessEnabled(state)
});

// Component must *not* be pure as to allow route updates to flow through
export const FlowSpaceRouter: React.ComponentClass<FlowSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, {pure: false})(FlowSpaceRouterComponent);
